import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Youtube } from 'lucide-react';
import Logo from './Logo';
import { useSettings } from '../contexts/SettingsContext';

export default function Footer() {
  const { settings } = useSettings();

  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="mb-4">
              <Logo variant="light" />
            </div>
            <p className="text-gray-300 mb-4">
              Professional tech repair and support services for all your devices.
            </p>
            <div className="flex space-x-4">
              <a
                href={settings.socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary transition-colors"
              >
                <svg 
                  viewBox="0 0 24 24" 
                  className="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a
                href={settings.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary transition-colors"
              >
                <Facebook size={24} />
              </a>
              <a
                href={settings.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary transition-colors"
              >
                <Instagram size={24} />
              </a>
              <a
                href={settings.socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary transition-colors"
              >
                <Youtube size={24} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-primary">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-primary">About Us</Link></li>
              <li><Link to="/knowledge-base" className="text-gray-300 hover:text-primary">Knowledge Base</Link></li>
              <li><Link to="/submit-ticket" className="text-gray-300 hover:text-primary">Submit a Ticket</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-primary">Contact</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" className="text-gray-300 hover:text-primary">Refund Policy</Link></li>
              <li><Link to="/feedback" className="text-gray-300 hover:text-primary">Customer Feedback</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Phone size={18} />
                <span>{settings.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} />
                <span>{settings.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>{settings.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Clock size={18} />
                <div>
                  <p>Mon-Fri: {settings.businessHours.monday}</p>
                  <p>Sat: {settings.businessHours.saturday}</p>
                  <p>Sun: {settings.businessHours.sunday}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            © {new Date().getFullYear()} {settings.companyName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}